/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
/* tslint:disable */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
import * as import0 from '../../../../app/subapps/recognizer/recognizer.component';
import * as import1 from '@angular/core/src/linker/view';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/metadata/view';
import * as import5 from '../../../../app/subapps/recognizer/nn.service';
import * as import6 from '../../../../app/subapps/recognizer/drawer.service';
import * as import7 from '@angular/core/src/linker/view_type';
import * as import8 from '@angular/core/src/change_detection/constants';
import * as import9 from '@angular/core/src/linker/component_factory';
import * as import10 from '@angular/core/src/linker/query_list';
import * as import11 from '@angular/core/src/change_detection/change_detection_util';
import * as import12 from '@angular/core/src/linker/element_ref';
export var Wrapper_RecognizerComponent = (function () {
    function Wrapper_RecognizerComponent(p0, p1) {
        this._changed = false;
        this.context = new import0.RecognizerComponent(p0, p1);
    }
    Wrapper_RecognizerComponent.prototype.ngOnDetach = function (view, componentView, el) {
    };
    Wrapper_RecognizerComponent.prototype.ngOnDestroy = function () {
        this.context.ngOnDestroy();
    };
    Wrapper_RecognizerComponent.prototype.ngDoCheck = function (view, el, throwOnChange) {
        var changed = this._changed;
        this._changed = false;
        if (!throwOnChange) {
            if ((view.numberOfChecks === 0)) {
                this.context.ngOnInit();
            }
        }
        return changed;
    };
    Wrapper_RecognizerComponent.prototype.checkHost = function (view, componentView, el, throwOnChange) {
    };
    Wrapper_RecognizerComponent.prototype.handleEvent = function (eventName, $event) {
        var result = true;
        return result;
    };
    Wrapper_RecognizerComponent.prototype.subscribe = function (view, _eventHandler) {
        this._eventHandler = _eventHandler;
    };
    return Wrapper_RecognizerComponent;
}());
var renderType_RecognizerComponent_Host = import3.createRenderComponentType('', 0, import4.ViewEncapsulation.None, [], {});
var View_RecognizerComponent_Host0 = (function (_super) {
    __extends(View_RecognizerComponent_Host0, _super);
    function View_RecognizerComponent_Host0(viewUtils, parentView, parentIndex, parentElement) {
        _super.call(this, View_RecognizerComponent_Host0, renderType_RecognizerComponent_Host, import7.ViewType.HOST, viewUtils, parentView, parentIndex, parentElement, import8.ChangeDetectorStatus.CheckAlways);
    }
    View_RecognizerComponent_Host0.prototype.createInternal = function (rootSelector) {
        this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer, 'recognizer', import3.EMPTY_INLINE_ARRAY, rootSelector, null);
        this.compView_0 = new View_RecognizerComponent0(this.viewUtils, this, 0, this._el_0);
        this._NNService_0_3 = new import5.NNService();
        this._DrawerService_0_4 = new import6.DrawerService(this._NNService_0_3);
        this._RecognizerComponent_0_5 = new Wrapper_RecognizerComponent(this.renderer, this._DrawerService_0_4);
        this.compView_0.create(this._RecognizerComponent_0_5.context);
        this.init(this._el_0, (this.renderer.directRenderer ? null : [this._el_0]), null);
        return new import9.ComponentRef_(0, this, this._el_0, this._RecognizerComponent_0_5.context);
    };
    View_RecognizerComponent_Host0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import5.NNService) && (0 === requestNodeIndex))) {
            return this._NNService_0_3;
        }
        if (((token === import6.DrawerService) && (0 === requestNodeIndex))) {
            return this._DrawerService_0_4;
        }
        if (((token === import0.RecognizerComponent) && (0 === requestNodeIndex))) {
            return this._RecognizerComponent_0_5.context;
        }
        return notFoundResult;
    };
    View_RecognizerComponent_Host0.prototype.detectChangesInternal = function (throwOnChange) {
        this._RecognizerComponent_0_5.ngDoCheck(this, this._el_0, throwOnChange);
        this.compView_0.detectChanges(throwOnChange);
        if (!throwOnChange) {
            if ((this.numberOfChecks === 0)) {
                this._RecognizerComponent_0_5.context.ngAfterViewInit();
            }
        }
    };
    View_RecognizerComponent_Host0.prototype.destroyInternal = function () {
        this.compView_0.destroy();
        this._RecognizerComponent_0_5.ngOnDestroy();
    };
    View_RecognizerComponent_Host0.prototype.visitRootNodesInternal = function (cb, ctx) {
        cb(this._el_0, ctx);
    };
    return View_RecognizerComponent_Host0;
}(import1.AppView));
export var RecognizerComponentNgFactory = new import9.ComponentFactory('recognizer', View_RecognizerComponent_Host0, import0.RecognizerComponent);
var styles_RecognizerComponent = [];
var renderType_RecognizerComponent = import3.createRenderComponentType('', 0, import4.ViewEncapsulation.None, styles_RecognizerComponent, {});
export var View_RecognizerComponent0 = (function (_super) {
    __extends(View_RecognizerComponent0, _super);
    function View_RecognizerComponent0(viewUtils, parentView, parentIndex, parentElement) {
        _super.call(this, View_RecognizerComponent0, renderType_RecognizerComponent, import7.ViewType.COMPONENT, viewUtils, parentView, parentIndex, parentElement, import8.ChangeDetectorStatus.CheckAlways);
        this._expr_44 = import11.UNINITIALIZED;
    }
    View_RecognizerComponent0.prototype.createInternal = function (rootSelector) {
        var parentRenderNode = this.renderer.createViewRoot(this.parentElement);
        this._viewQuery_sketchpad_0 = new import10.QueryList();
        this._viewQuery_thumbnail_1 = new import10.QueryList();
        this._el_0 = import3.createRenderElement(this.renderer, parentRenderNode, 'div', new import3.InlineArray4(4, 'class', 'container-fluid', 'id', 'container'), null);
        this._text_1 = this.renderer.createText(this._el_0, '\n    ', null);
        this._el_2 = import3.createRenderElement(this.renderer, this._el_0, 'div', new import3.InlineArray2(2, 'class', 'row'), null);
        this._text_3 = this.renderer.createText(this._el_2, '\n        ', null);
        this._el_4 = import3.createRenderElement(this.renderer, this._el_2, 'h3', import3.EMPTY_INLINE_ARRAY, null);
        this._text_5 = this.renderer.createText(this._el_4, 'Recognizing hand-written digits from MNIST dataset with Brain.js. Neural Networks live example.', null);
        this._text_6 = this.renderer.createText(this._el_2, '\n        ', null);
        this._el_7 = import3.createRenderElement(this.renderer, this._el_2, 'p', import3.EMPTY_INLINE_ARRAY, null);
        this._text_8 = this.renderer.createText(this._el_7, '\n            Draw a digit in the box below and click the "recognize" button.\n        ', null);
        this._text_9 = this.renderer.createText(this._el_2, '\n    ', null);
        this._text_10 = this.renderer.createText(this._el_0, '\n    ', null);
        this._el_11 = import3.createRenderElement(this.renderer, this._el_0, 'div', new import3.InlineArray2(2, 'class', 'row'), null);
        this._text_12 = this.renderer.createText(this._el_11, '\n        ', null);
        this._el_13 = import3.createRenderElement(this.renderer, this._el_11, 'div', new import3.InlineArray2(2, 'class', 'col-lg-9 col-md-9 col-sm-9 col-xs-9'), null);
        this._text_14 = this.renderer.createText(this._el_13, '\n            ', null);
        this._el_15 = import3.createRenderElement(this.renderer, this._el_13, 'canvas', new import3.InlineArray8(6, 'class', 'img-thumbnail', 'height', '280', 'width', '280'), null);
        this._text_16 = this.renderer.createText(this._el_15, 'Sorry, your browser is not supported.\n            ', null);
        this._text_17 = this.renderer.createText(this._el_13, '\n        ', null);
        this._text_18 = this.renderer.createText(this._el_11, '\n        ', null);
        this._el_19 = import3.createRenderElement(this.renderer, this._el_11, 'div', new import3.InlineArray2(2, 'class', 'col-lg-3 col-md-3 col-sm-3 col-xs-3'), null);
        this._text_20 = this.renderer.createText(this._el_19, '\n            ', null);
        this._el_21 = import3.createRenderElement(this.renderer, this._el_19, 'div', new import3.InlineArray2(2, 'class', 'col-lg-12 col-md-12 col-sm-12 col-xs-12'), null);
        this._text_22 = this.renderer.createText(this._el_21, '\n                ', null);
        this._el_23 = import3.createRenderElement(this.renderer, this._el_21, 'canvas', new import3.InlineArray8(6, 'class', 'img-thumbnail', 'height', '28', 'width', '28'), null);
        this._text_24 = this.renderer.createText(this._el_23, 'Sorry, your browser is not supported.\n                ', null);
        this._text_25 = this.renderer.createText(this._el_21, '\n            ', null);
        this._text_26 = this.renderer.createText(this._el_19, '\n            ', null);
        this._el_27 = import3.createRenderElement(this.renderer, this._el_19, 'div', new import3.InlineArray2(2, 'class', 'col-lg-12 col-md-12 col-sm-12 col-xs-12'), null);
        this._text_28 = this.renderer.createText(this._el_27, '\n                ', null);
        this._el_29 = import3.createRenderElement(this.renderer, this._el_27, 'h1', import3.EMPTY_INLINE_ARRAY, null);
        this._text_30 = this.renderer.createText(this._el_29, '', null);
        this._text_31 = this.renderer.createText(this._el_27, '\n            ', null);
        this._text_32 = this.renderer.createText(this._el_19, '\n        ', null);
        this._text_33 = this.renderer.createText(this._el_11, '\n    ', null);
        this._text_34 = this.renderer.createText(this._el_0, '\n', null);
        this._text_35 = this.renderer.createText(parentRenderNode, '\n', null);
        this._el_36 = import3.createRenderElement(this.renderer, parentRenderNode, 'button', new import3.InlineArray2(2, 'class', 'btn btn-default'), null);
        this._text_37 = this.renderer.createText(this._el_36, 'Clear', null);
        this._text_38 = this.renderer.createText(parentRenderNode, '\n', null);
        this._el_39 = import3.createRenderElement(this.renderer, parentRenderNode, 'button', new import3.InlineArray2(2, 'class', 'btn btn-primary'), null);
        this._text_40 = this.renderer.createText(this._el_39, 'Recognise', null);
        this._text_41 = this.renderer.createText(parentRenderNode, '\n\n', null);
        var disposable_0 = import3.subscribeToRenderElement(this, this._el_15, new import3.InlineArray16(12, 'touchstart', null, 'touchmove', null, 'touchend', null, 'mousedown', null, 'mousemove', null, 'mouseup', null), this.eventHandler(this.handleEvent_15));
        var disposable_1 = import3.subscribeToRenderElement(this, this._el_36, new import3.InlineArray2(2, 'click', null), this.eventHandler(this.handleEvent_36));
        var disposable_2 = import3.subscribeToRenderElement(this, this._el_39, new import3.InlineArray2(2, 'click', null), this.eventHandler(this.handleEvent_39));
        this._viewQuery_sketchpad_0.reset([new import12.ElementRef(this._el_15)]);
        this.context.sketchpadEl = this._viewQuery_sketchpad_0.first;
        this._viewQuery_thumbnail_1.reset([new import12.ElementRef(this._el_23)]);
        this.context.thumbnailEl = this._viewQuery_thumbnail_1.first;
        this.init(null, (this.renderer.directRenderer ? null : [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._el_4,
            this._text_5,
            this._text_6,
            this._el_7,
            this._text_8,
            this._text_9,
            this._text_10,
            this._el_11,
            this._text_12,
            this._el_13,
            this._text_14,
            this._el_15,
            this._text_16,
            this._text_17,
            this._text_18,
            this._el_19,
            this._text_20,
            this._el_21,
            this._text_22,
            this._el_23,
            this._text_24,
            this._text_25,
            this._text_26,
            this._el_27,
            this._text_28,
            this._el_29,
            this._text_30,
            this._text_31,
            this._text_32,
            this._text_33,
            this._text_34,
            this._text_35,
            this._el_36,
            this._text_37,
            this._text_38,
            this._el_39,
            this._text_40,
            this._text_41
        ]), [
            disposable_0,
            disposable_1,
            disposable_2
        ]);
        return null;
    };
    View_RecognizerComponent0.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_44 = import3.inlineInterpolate(1, '\n                    ', this.context.drawerService.result, '\n                ');
        if (import3.checkBinding(throwOnChange, this._expr_44, currVal_44)) {
            this.renderer.setText(this._text_30, currVal_44);
            this._expr_44 = currVal_44;
        }
    };
    View_RecognizerComponent0.prototype.handleEvent_15 = function (eventName, $event) {
        this.markPathToRootAsCheckOnce();
        var result = true;
        if ((eventName == 'touchstart')) {
            var pd_sub_0 = (this.context.draw($event) !== false);
            result = (pd_sub_0 && result);
        }
        if ((eventName == 'touchmove')) {
            var pd_sub_1 = (this.context.draw($event) !== false);
            result = (pd_sub_1 && result);
        }
        if ((eventName == 'touchend')) {
            var pd_sub_2 = (this.context.draw($event) !== false);
            result = (pd_sub_2 && result);
        }
        if ((eventName == 'mousedown')) {
            var pd_sub_3 = (this.context.draw($event) !== false);
            result = (pd_sub_3 && result);
        }
        if ((eventName == 'mousemove')) {
            var pd_sub_4 = (this.context.draw($event) !== false);
            result = (pd_sub_4 && result);
        }
        if ((eventName == 'mouseup')) {
            var pd_sub_5 = (this.context.draw($event) !== false);
            result = (pd_sub_5 && result);
        }
        return result;
    };
    View_RecognizerComponent0.prototype.handleEvent_36 = function (eventName, $event) {
        this.markPathToRootAsCheckOnce();
        var result = true;
        if ((eventName == 'click')) {
            var pd_sub_0 = (this.context.clear() !== false);
            result = (pd_sub_0 && result);
        }
        return result;
    };
    View_RecognizerComponent0.prototype.handleEvent_39 = function (eventName, $event) {
        this.markPathToRootAsCheckOnce();
        var result = true;
        if ((eventName == 'click')) {
            var pd_sub_0 = (this.context.recognise() !== false);
            result = (pd_sub_0 && result);
        }
        return result;
    };
    return View_RecognizerComponent0;
}(import1.AppView));
//# sourceMappingURL=recognizer.component.ngfactory.js.map